exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container__CompanyUsersSearchSelect-module___2Obw8 {\n  width: 100%;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.tooltip__CompanyUsersSearchSelect-module___2D9Oc > :nth-child(2) {\n  background-color: #f1f2fe;\n  color: #0183d5;\n}\n\n.tooltip__CompanyUsersSearchSelect-module___2D9Oc > :nth-child(1)::before {\n  content: '';\n  border-right-color: #0183d5;\n}\n\n.tooltip2__CompanyUsersSearchSelect-module___1fQ3W {\n  display: none;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "container__CompanyUsersSearchSelect-module___2Obw8",
	"tooltip": "tooltip__CompanyUsersSearchSelect-module___2D9Oc",
	"tooltip2": "tooltip2__CompanyUsersSearchSelect-module___1fQ3W"
};